import React, {useEffect, useMemo, useState} from "react";
import "../style/Main.scss";
import strongPoint from "../assets/images/Main/strong_point.png";
import secondImg1 from "../assets/images/Main/second_img_1.png";
import secondImg2 from "../assets/images/Main/second_img_2.png";
import secondImg3 from "../assets/images/Main/second_img_3.png";
import thirdImg from "../assets/images/Main/third_img.png"
import fourthImg from "../assets/images/Main/fourth_img.png"
import sixthImg from "../assets/images/Main/six_img.png"
import seventhImg1 from "../assets/images/Main/seventh_img_1.png"
import seventhImg2 from "../assets/images/Main/seventh_img_2.png"
import seventhImg3 from "../assets/images/Main/seventh_img_3.png"
import seventhImg4 from "../assets/images/Main/seventh_img_4.png"
import eighthImg from "../assets/images/Main/eighth_img.png"
import Footer from "../components/Footer";
import landingBackground1 from "../assets/images/Main/landing_background_1.png"
import landingBackground2 from "../assets/images/Main/landing_background_2.png"
import landingBackground3 from "../assets/images/Main/landing_background_3.png"
function Main(props) {

  const [selectedTab, setSelectedTab] = useState('WALLET');
  const onClickTab = (tab) => {
    setSelectedTab(tab);
  }

  const seventhSectionImg = useMemo(()=>{
    switch (selectedTab){
      case 'WALLET':
        return seventhImg1;
      case 'NODE MANAGE':
        return seventhImg2;
      case 'BLOCK EXPLORER':
        return seventhImg3;
      case 'DEX':
        return seventhImg4;
    }
  },[selectedTab])

  return (
      <div id={"Main"}>

        <div className="content-wrapper">
          <div className="landing-content-wrapper">
            <div className="first-section-wrapper">
              <div className="title-wrapper">
                <div className="title-row-wrapper">UNLEASH THE</div>
                <div className="title-row-wrapper">
                  <div className="bold-title right">POWER</div>
                  OF
                  <div className="bold-title left">INSTANT</div>
                </div>
                <div className="title-row-wrapper">BLOCKCHAIN</div>
              </div>
              <div className="point-wrapper">
                <div className="strong-point-wrapper">
                  <div className="strong-point-row">
                    <img className='strong-point-img' src={strongPoint} alt={''}/>
                    <div className="strong-point-text">SECURITY</div>
                  </div>
                  <div className="strong-point-row">
                    <img className='strong-point-img' src={strongPoint} alt={''}/>
                    <div className="strong-point-text">INNOVATIVE</div>
                  </div>
                  <div className="strong-point-row">
                    <img className='strong-point-img' src={strongPoint} alt={''}/>
                    <div className="strong-point-text">ACCESSIBILITY</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="landing-content-wrapper">
            <div className="second-section-wrapper">
              <div className="sub-title-wrapper">
                <div className="sub-title-text">KEY METRICS</div>
              </div>
              <div className="title-wrapper">{"REVOLUTIONIZING BLOCKCHAIN:\nVERIA’S GAME CHANGING FEATURES"}</div>
              <div className="second-section-img-wrapper">
                <div className="card-wrapper">
                  <img className="card-img" src={secondImg1} alt={''}/>
                  <div className="card-title">5,300 TPS</div>
                  <div
                      className="card-description">{"PER MICRO-CHAIN SCALABLE WITH ADDITIONAL INTEROPERABLE MICRO-CHAINS"}</div>
                </div>
                <div className="card-wrapper middle">
                  <img className="card-img" src={secondImg2} alt={''}/>
                  <div className="card-title">1-3 SECOND</div>
                  <div className="card-description">{"FINALIZATION RAPID TRANSACTIONS FOR TRADING, GAMING & MORE"}</div>
                </div>
                <div className="card-wrapper">
                  <img className="card-img" src={secondImg3} alt={''}/>
                  <div className="card-title">13,500 TXS</div>
                  <div className="card-description">{"PER BLOCK LARGE BLOCKS FOR SCALABILITY & LOW FEES"}</div>
                </div>
              </div>
            </div>
          </div>
          <div className="landing-content-wrapper">
            <div className="third-section-wrapper">
              <div className="left-content-wrapper">
                <div className="third-title-wrapper">KEY ELEMENTS OF TOKEN ECONOMICS</div>
                <img className="third-img" src={thirdImg} alt={''}/>
              </div>
              <div className="right-content-wrapper">
                <div className="third-card-wrapper">
                  <div className="third-card-title">1. LUCRATIVE VALIDATOR RETURNS</div>
                  <div className="third-card-main-text">10% APPROXIMATE VALIDATOR YIELD</div>
                  <div className="third-card-description">VALIDATORS SECURE VERIA WITH YEARLY REWARDS</div>
                </div>
                <div className="third-card-wrapper middle">
                  <div className="third-card-title">2. LONG-TERM TOKEN DISTRIBUTION</div>
                  <div className="third-card-main-text">LOW TOKEN UNLOCKS</div>
                  <div className="third-card-description">GRADUAL TOKEN RELEASE OVER 20 YEARS</div>
                </div>
                <div className="third-card-wrapper">
                  <div className="third-card-title">3. REVENUE SHARING MODEL</div>
                  <div className="third-card-main-text">FEE SHARE SYSTEM</div>
                  <div className="third-card-description">GRADUAL TOKEN RELEASE OVER 20 YEARS</div>
                </div>
              </div>
            </div>
          </div>
          <div className="landing-content-wrapper">
            <div className="fourth-section-wrapper">
              <div className="fourth-card-wrapper">
                <div className="fourth-title">EMPOWERING DEVELOPERS PROTECTING USERS</div>
                <div className="fourth-description">VERIA COMBINES ADVANCED SECURITY MEASURES WITH USER-FRIENDLY
                  DEVELOPMENT TOOLS, CREATING A BLOCKCHAIN ECOSYSTEM THAT'S BOTH SAFE AND ACCESSIBLE.
                </div>
                <div className="fourth-card-in-wrapper">
                  <img className="card-in-img" src={fourthImg} alt={''}/>
                  <div className="card-in-title">FRONT-RUNNING PREVENTION</div>
                  <div className="card-in-green-box">VALIDATORS CANNOT FRONT-RUN TRANSACTIONS, ENSURING FAIR TRADING
                    NO-CODE TOOLKIT FOR BUILDING ON-CHAIN APPS AND GAMES
                  </div>
                </div>
              </div>

            </div>
          </div>
          <div className="landing-content-wrapper background">
            <img className='fifth-background' src={landingBackground3} alt={''}/>

            <div className="fifth-section-wrapper">
              <div className="fifth-card-content-wrapper">
                <div className="fifth-card-wrapper black">
                  <div className="fifth-card-top-wrapper">
                    <div className="fifth-card-title">VERIA DNA</div>
                    <div className="fifth-card-description">VERIA IS OUR INNOVATIVE BLOCKCHAIN SOLUTION, DESIGNED TO
                      MEET
                      THE DEMANDING REQUIREMENTS OF MODERN GAMING AND DECENTRALIZED APPLICATIONS. IT COMBINES HIGH
                      PERFORMANCE WITH ACCESSIBILITY, RUNNING ON A WIDE RANGE OF HARDWARE.
                    </div>
                  </div>
                  <div className="fifth-card-btn-wrapper">
                    <div className="fifth-card-btn-row first">
                      <div className="fifth-card-btn first">DECENTRALIZED</div>
                      <div className="fifth-card-btn">SCALABLE</div>
                    </div>
                    <div className="fifth-card-btn-row">
                      <div className="fifth-card-btn first">SECURE</div>
                      <div className="fifth-card-btn">HARDWARE FLEXIBLE</div>
                    </div>
                  </div>
                </div>
                <div className="fifth-card-wrapper">
                  <div className="fifth-card-top-wrapper">
                    <div className="fifth-card-title">GAME DNA</div>
                    <div className="fifth-card-description">OUR TEAM BRINGS A WEALTH OF EXPERIENCE FROM THE GAMING
                      INDUSTRY. WE UNDERSTAND THE UNIQUE CHALLENGES AND REQUIREMENTS OF CREATING ENGAGING, RESPONSIVE,
                      AND ACCESSIBLE GAMING EXPERIENCES.
                    </div>
                  </div>
                  <div className="fifth-card-btn-wrapper">
                    <div className="fifth-card-btn-row first">
                      <div className="fifth-card-btn first">STABLE PERFORMANCE</div>
                      <div className="fifth-card-btn">RESPONSIVE</div>
                    </div>
                    <div className="fifth-card-btn-row">
                      <div className="fifth-card-btn first">CROSS-PLATFORM</div>
                      <div className="fifth-card-btn">MOBILE OPTIMIZED</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="landing-content-wrapper">
            <div className="sixth-section-wrapper">
              <div className="sixth-title-wrapper">
                <div className="sixth-title">COMMUNITY-CENTRIC</div>
              </div>
              <div className="sixth-description">TOKENOMICS: 78% DISTRIBUTED</div>
              <div className="sixth-img-wrapper">
                <img className="sixth-img" src={sixthImg} alt={''}/>
              </div>
              <div className="sixth-card-wrapper">
                <div className="sixth-card">
                  <div className="sixth-card-title">TOKEN
                    DISBURSEMENT:
                  </div>
                  <div className="sixth-card-data-wrapper">
                    <div className="sixth-card-data-row">· MODEST ALLOCATIONS</div>
                    <div className="sixth-card-data-row">· EARLY INVESTORS: LONG LOCKUP</div>
                    <div className="sixth-card-data-row">· LATER INVESTORS: 12-MONTH LOCKUP, 18-MONTH VESTING</div>
                    <div className="sixth-card-data-row">· TEAM: 18-MONTH LOCKUP AND VESTING</div>
                  </div>
                </div>
                <div className="sixth-card middle">
                  <div className="sixth-card-title">INVESTOR AND TEAM ALLOCATIONS:</div>
                  <div className="sixth-card-data-wrapper">
                    <div className="sixth-card-data-row">· MODEST ALLOCATIONS</div>
                    <div className="sixth-card-data-row">· EARLY INVESTORS: LONG LOCKUP</div>
                    <div className="sixth-card-data-row">· LATER INVESTORS: 12-MONTH LOCKUP, 18-MONTH VESTING</div>
                    <div className="sixth-card-data-row">· TEAM: 18-MONTH LOCKUP AND VESTING</div>
                  </div>
                </div>
                <div className="sixth-card">
                  <div className="sixth-card-title">TRANSACTION FEE DISTRIBUTION:</div>
                  <div className="sixth-card-data-wrapper">
                    <div className="sixth-card-data-row">· MODEST ALLOCATIONS</div>
                    <div className="sixth-card-data-row">· EARLY INVESTORS: LONG LOCKUP</div>
                    <div className="sixth-card-data-row">· LATER INVESTORS: 12-MONTH LOCKUP, 18-MONTH VESTING</div>
                    <div className="sixth-card-data-row">· TEAM: 18-MONTH LOCKUP AND VESTING</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="landing-content-wrapper">
            <div className="seventh-section-wrapper">
              <div className="seventh-header">
                <div className="seventh-header-text">CORE ECOSYSTEM COMPONENTS</div>

              </div>
              <div className="seventh-title">POWERING THE VERIA NETWORK:
                YOUR COMPLETE TOOLKIT
              </div>
              <div className="seventh-description">DIVE INTO THE HEART OF VERIA WITH OUR INTEGRATED SUITE OF TOOLS. FROM
                NODE MANAGEMENT TO BLOCKCHAIN EXPLORATION AND DECENTRALIZED TRADING, WE PROVIDE EVERYTHING YOU NEED TO
                FULLY ENGAGE WITH AND BENEFIT FROM THE VERIA ECOSYSTEM. EXPERIENCE THE SYNERGY OF OUR CAREFULLY CRAFTED
                COMPONENTS WORKING TOGETHER SEAMLESSLY
              </div>
              <div className="seventh-btn-wrapper">
                <div className={selectedTab==='WALLET' ? "seventh-btn selected":"seventh-btn"} onClick={()=>onClickTab('WALLET')}>WALLET</div>
                <div className={selectedTab==='NODE MANAGE' ? "seventh-btn selected":"seventh-btn"} onClick={()=>onClickTab('NODE MANAGE')}>NODE MANAGE</div>
                <div className={selectedTab==='BLOCK EXPLORER' ? "seventh-btn selected":"seventh-btn"} onClick={()=>onClickTab('BLOCK EXPLORER')}>BLOCK EXPLORER</div>
                <div className={selectedTab==='DEX' ? "seventh-btn selected":"seventh-btn"} onClick={()=>onClickTab('DEX')}>DEX</div>
              </div>
              <div className="seventh-banner">
                <img className="seventh-banner-img" src={seventhSectionImg} alt={''}/>
                {
                  selectedTab === 'WALLET' &&
                    <div className="seventh-banner-content-wrapper">
                      <div className="seventh-banner-title">CROSS-CHAIN ASSET MANAGEMENT WALLET</div>
                      <div className="seventh-banner-description">SEAMLESSLY MANAGE ASSETS ACROSS BLOCKCHAINS. OUR INTERFACE
                        SIMPLIFIES TRANSACTIONS, UNLOCKING OPPORTUNITIES THROUGHOUT THE CRYPTO ECOSYSTEM.
                      </div>
                    </div>
                }
                {
                    selectedTab === 'NODE MANAGE' &&
                    <div className="seventh-banner-content-wrapper">
                      <div className="seventh-banner-title">NO-CODE HIGH SECURE NODE MANAGEMENT CONSOLE</div>
                      <div className="seventh-banner-description">EXPERIENCE VERIA HUB'S EXCLUSIVE NODE CONSOLE—OPERATE HIGHLY SECURE NODES WITHOUT CODING.
                      </div>
                    </div>
                }
                {
                    selectedTab === 'BLOCK EXPLORER' &&
                    <div className="seventh-banner-content-wrapper">
                      <div className="seventh-banner-title">REAL-TIME, EASY EXPLORER</div>
                      <div className="seventh-banner-description">WE PROVIDE A SEAMLESS EXPLORER FOR EASIER AND FASTER ON-CHAIN EVENT MONITORING—PLUS POWERFUL ANALYTICS!
                      </div>
                    </div>
                }
                {
                    selectedTab === 'DEX' &&
                    <div className="seventh-banner-content-wrapper">
                      <div className="seventh-banner-title">INTERACT WITH OTHER MAINNET ASSETS</div>
                      <div className="seventh-banner-description">THERE ARE MANY MAINNETS, AND TO EXPAND THE VERIA ECOSYSTEM, WE SUPPORT EXCHANGES WITH VARIOUS ASSETS.</div>
                    </div>
                }
              </div>
            </div>
          </div>
          <div className="landing-content-wrapper">
            <div className="eighth-section-wrapper">
              <div className="eighth-title">MEET THE VISIONARIES BEHIND VERIA</div>
              <div className="eighth-content-box">
                <div className="eighth-introduce-wrapper">
                  <div className="eighth-introduce-title">OUR TEAM</div>
                  <div className="eighth-introduce-text">
                    <div className="eighth-introduce-paragraph">PAULUS J. LEE, THE FOUNDING FATHER OF THE KOREAN GAME
                      INDUSTRY, WAS AN EARLY PIONEER IN GAME ENGINES AND 3D ANIMATION TECHNOLOGY. HE DEVELOPED A METHOD
                      TO RENDER 3D GRAPHICS QUICKLY ON LOW-SPEC DEVICES AT SCALE.
                    </div>
                    <div className="eighth-introduce-paragraph middle">TOGETHER WITH A GROUP OF TOP-TIER DEVELOPERS FROM
                      SKKU, SEOUL NATIONAL UNIVERSITY, KAIST, AND KOREA UNIVERSITY, PAULUS DESIGNED 3RD GENERATION
                      BLOCKCHAIN TECHNOLOGY BASED ON THE NOVEL PROOF OF NONCE CONSENSUS ALGORITHM.
                    </div>
                    <div className="eighth-introduce-paragraph">TODAY WE ARE PROUD TO HAVE AN EXTRAORDINARILY TALENTED
                      TEAM OF OVER 40 DEVELOPERS WITH A WEALTH OF EXPERTISE IN THE GAMING INDUSTRY, CRYPTOGRAPHY,
                      DISTRIBUTED SYSTEMS.
                    </div>
                  </div>
                  <div className="eighth-introduce-btn">
                    <div className="eighth-introduce-btn-text">READ OUR MISSION</div>
                  </div>
                </div>
                <img src={eighthImg} alt="" className="eighth-introduce-img"/>
              </div>
            <Footer/>
            </div>
          </div>
        </div>
      </div>

  );
}

export default Main;
